import { pushToDataLayer } from '../../lib/pushToDataLayer';

export const pushChatSession = (chatId: string | null) => {
  pushToDataLayer({ event: 'chat_initiated', chatId });
};
